<app-tab-layout [loading]="loading()">
  <div class="draft-tab">
    @if (loading()) {
      <div class="loading-skeleton">
        @for (item of [1, 2, 3]; track item) {
          <div class="skeleton-item">
            <app-wiper-loading />
          </div>
        }
      </div>
    } @else if (planDrafts().length === 0) {
      <div class="empty-state">
        <p>{{ dictionaryService.get('NoPlanDraftsFound') }}</p>
      </div>
    } @else {
      <div class="representatives-list">
        @for (rep of planDrafts(); track rep.name) {
          <app-accordion [title]="rep.name">
            <div class="dates-list">
              @for (dateItem of rep.dates; track dateItem.id) {
                <app-accordion 
                  [title]="(dateItem.date | date: 'dd/MM/yyyy') ?? dateItem.date"
                  (toggled)="onDateAccordionToggled(dateItem.id, $event)">
                  <div class="date-content">
                    @if (isDateOpened(dateItem.id)) {
                      <app-api-table 
                        [endpoint]="getTableEndpoint(dateItem.id)"
                        [name]="'Plan Draft - ' + (dateItem.date | date: 'dd/MM/yyyy')"
                        [hasIndexCol]="true"
                        [hasChartView]="false"
                        [skipFilters]="true"
                        #apiTable
                        >
                      </app-api-table>
                      @if (showActionButtons() && apiTable.tableComponent && !apiTable.tableComponent.tableContext.isLoading()) {
                        <div class="action-buttons">
                          <button 
                            buttonTheme="primary" 
                            buttonType="square"
                            size="sm"
                            (click)="approvePlanDraft(dateItem.id); $event.stopPropagation()"
                            [disabled]="isProcessing()"
                            [attr.aria-label]="dictionaryService.get('Approve')">
                            <ng-icon name="iconoirCheck" size="20" strokeWidth="2.5"></ng-icon>
                          </button>
                          <button 
                            buttonTheme="light" 
                            buttonType="square"
                            size="sm"
                            (click)="openRejectionModal(dateItem.id); $event.stopPropagation()"
                            [disabled]="isProcessing()"
                            [attr.aria-label]="dictionaryService.get('Reject')">
                            <ng-icon name="iconoirXmark" size="20" strokeWidth="2.5"></ng-icon>
                          </button>
                        </div>
                      }
                    }
                  </div>
                </app-accordion>
              }
            </div>
          </app-accordion>
        }
      </div>
    }
  </div>
</app-tab-layout>

<!-- Rejection Modal -->
<app-rejection-modal
  [(isOpen)]="isRejectionModalOpen"
  [isProcessing]="isProcessing()"
  (onSubmit)="handleRejectionSubmit($event)"
  (onClose)="closeRejectionModal()"
></app-rejection-modal>
